/**
 * @file     pageContent.ts
 * @purpose  Defines i18n-ready content schema for the blog post detail page.
 */
import { localizedText, useResolvedContent } from '@/core/content';

const blogPostPageContentSchema = {
  breadcrumbHome: localizedText('pages.blogPost.breadcrumb.home', 'Home'),
  breadcrumbBlog: localizedText('pages.blogPost.breadcrumb.blog', 'Blog'),
  relatedPosts: {
    title: localizedText(
      'pages.blogPost.relatedPosts.title',
      'More to read',
    ),
  },
  byline: localizedText(
    'pages.blogPost.byline',
    'By {{name}}',
  ),
};

export const useBlogPostContent = () =>
  useResolvedContent(blogPostPageContentSchema);
